module.exports = __webpack_public_path__ + "static/rs-logo-white-2-660c9c2cd861e85c755f446ec61bda4a.svg";